import * as convertServiceTiming from "./convertServiceTiming";
import * as stringHexConversion from "./stringHexConversion";
import * as convertSchoolGrade from "./convertSchoolGrade";
import * as cookiesValue from "./auth.cookiesValue";

import convertISOToNormalDateWithoutHour from "./convertISOToNormalDateWithoutHour";
import convertNumberToPrice from "./convertNumberToPrice";
import convertPriceToNumber from "./convertPriceToNumber";
import convertGregorianToJalali from "./convertGregorianToJalali";
import convertJalaliToGregorian from "./convertJalaliToGregorian";
import convertISOToNormalDate from "./convertISOToNormalDate";
import convertNumbers2English from "./convertNumbers2English";
import hyphenfyMobileNumber from "./hyphenfyMobileNumber";
import hyphenfyPhoneNumber from "./hyphenfyPhoneNumber";
import successHandler from "./successHandler";
import errorHandler from "./errorHandler";
import setLoginData from "./setLoginData";
import toast from "./toast";
import convertStringToObjectProperty from "./convertStringToObjectProperty";
import remainDays from "./remainDays";

const utils = {
  cookiesValue,
  convertSchoolGrade,
  stringHexConversion,
  convertServiceTiming,

  toast,
  errorHandler,
  setLoginData,
  successHandler,
  hyphenfyPhoneNumber,
  hyphenfyMobileNumber,
  convertNumbers2English,
  convertISOToNormalDate,
  convertGregorianToJalali,
  convertJalaliToGregorian,
  convertISOToNormalDateWithoutHour,
  convertStringToObjectProperty,
  convertNumberToPrice,
  convertPriceToNumber,
  remainDays,
};

export default utils;
